// Arquivo de exportação para funções de autenticação
import { isAuthenticated, getUser, login, logout } from './auth/simpleAuth';

// Função para obter o token de autenticação (para uso em requisições)
export const getAuthToken = () => {
  try {
    const authData = localStorage.getItem('fileshare_auth');
    if (!authData) return null;
    
    const user = JSON.parse(authData);
    // Como estamos usando autenticação simples, não temos um token real
    // Então vamos usar o email como "token" para identificação
    return user.email || null;
  } catch (error) {
    console.error('Erro ao obter token de autenticação:', error);
    return null;
  }
};

// Re-exportar as funções do simpleAuth
export { isAuthenticated, getUser, login, logout };
